<script>
import { mapGetters } from 'vuex'

import { apiSecond } from '@/boot/axios'

import MainFilters from '@/components/MainFilters.vue'

// Выгрузка формируется в очереди на бэке: POST ставит задание, статус опрашиваем.
const EXPORT_POLL_INTERVAL = 2500
const EXPORT_MAX_ATTEMPTS = 120 // ~5 минут ожидания, дальше считаем выгрузку неудачной

export default {
	name: 'TradeListPage',
	components: { MainFilters },
	props: {
		user: {
			type: Object,
		},
	},
	data() {
		return {
			applications: [],
			totalItems: null,
			errorMessage: {
				status: null,
				text: null,
				messages: null,
			},
			message: {
				status: null,
				text: null,
			},

			blockElemet: null,
			unlockElemet: null,
			// Страница и размер берутся из query, чтобы после обновления открылась та же страница
			options: {
				itemsPerPage: Number(this.$route.query.per_page) || 10,
				page: Number(this.$route.query.page) || 1,
			},
			headers: [
				{ text: 'Id', value: 'id', width: '50px', sortable: false },
				{
					text: this.$t('headers.name_company') + ' / ' + this.$t('headers.fio'),
					value: 'name_company',
					width: '23vw',
					sortable: false,
				},
				// { text: this.$t('headers.iin_bin'), value: 'iin_bin', sortable: false, width: '10vw' },
				{ text: this.$t('headers.regions'), value: 'regions', sortable: false, width: '10vw' },
				{
					text: this.$t('labels.catch_type'),
					value: 'catch_types',
					sortable: false,
					width: '10vw',
				},
				{
					text: this.$t('headers.register_at'),
					value: 'created_at',
					width: '10vw',
					sortable: false,
				},
				{
					text: this.$t('headers.action'),
					value: 'action',
					align: 'left',
					sortable: false,
					width: '200px',
				},
			],

			fileDocuments: {
				file: null,
				fileName: '',
				fileClass: '',
			},
			filters: {
				regions: [],
				search: null,
				reservoirs: null,
				start_at: null,
				catch_type: null,
			},

			subjectKinds: ['fishery', 'aquaculture', 'feed_producer'],
			exporting: false,
			exportTimer: null,
			exportCancelled: false,
		}
	},
	computed: {
		...mapGetters(['_getUserObject']),
		getFilters() {
			if (this.isTir) return ['search', 'regions', 'reservoirs', 'start_at', 'catch_type']
			return ['search', 'pools', 'regions', 'reservoirs', 'start_at', 'catch_type']
		},
		isTir() {
			return this.$store.state.userObject?.role?.name === 'tir'
		},
		restrictedRegionIds() {
			if (!this.isTir) return []
			const regions = this.$store.state.userObject?.regions || []
			return regions.map((r) => r.region_id).filter((id) => id != null)
		},
	},
	methods: {
		search() {
			this.options.page = 1
			this.pagination(this.options)
		},
		handleFileUpload() {
			this.message.status = null
			this.message.text = null
			this.message.texts = null
			this.errorMessage = {
				status: null,
				text: null,
				messages: null,
			}
			this.fileDocuments.file = this.$refs.fileDocuments.files[0]
			this.fileDocuments.fileName = this.$refs.fileDocuments.files[0].name
			this.fileDocuments.fileClass = 'add_tourist--success'
		},
		pagination(options) {
			this.syncPageToQuery(options)
			this.apiGetUserDocumentList(options.page, options.itemsPerPage, options)
		},
		setSubjectKind(kind) {
			this.$router
				.replace({ query: { ...this.$route.query, subject_kind: kind || undefined, page: 1 } })
				.catch(() => {})
				.then(() => this.search())
		},
		syncPageToQuery({ page, itemsPerPage }) {
			const query = this.$route.query
			if (Number(query.page) === page && Number(query.per_page) === itemsPerPage) return
			this.$router.replace({ query: { ...query, page, per_page: itemsPerPage } }).catch(() => {})
		},
		apiGetUserDocumentList(page = 1, per_page = 10, options) {
			const params = {
				...this.$route.query,
				page,
				per_page,
			}
			if (params['start_at']) {
				params['created_at'] = params['start_at']
				delete params['start_at']
			}
			// Normalize catch type params from query into axios-friendly catch_type_id (array)
			// Accept any of: catch_type_id (preferred), catch_type, catch_type_id[]
			{
				const rawCatchType =
					params['catch_type_id'] ?? params['catch_type'] ?? params['catch_type_id[]']
				if (rawCatchType !== undefined && rawCatchType !== null) {
					const asArray = Array.isArray(rawCatchType) ? rawCatchType : [rawCatchType]
					const cleaned = asArray
						.map((v) => (v != null ? String(v) : ''))
						.filter((v) => v !== '' && v !== 'undefined')
						.map((v) => (isNaN(Number(v)) ? v : Number(v)))
					if (cleaned.length) {
						params['catch_type_id'] = cleaned
					}
				}
				// Clean duplicates, keep only catch_type_id
				delete params['catch_type_id[]']
				delete params['catch_type']
			}
			if (options?.sortBy?.length) {
				params[`sort[${options.sortBy[0]}]`] =
					!options.sortDesc?.length || !options.sortDesc[0] ? 'asc' : 'desc'
			}
			apiSecond
				.get(`v1/user/region/list`, {
					params: params,
				})
				.then((response) => {
					if (response.data) {
						this.applications = response.data.data
						this.totalItems = response.data.total
					}
				})
				.catch((error) => {
					if (error?.response?.status == 500) {
						this.errorMessage.status = 500
						this.errorMessage.text = this.$t('system_message.500')
					}
					if (error?.response?.status == 401) {
						this.errorMessage.status = 401
						this.errorMessage.text = error.response.data.error_message
						this.$router.push('/' + this.$i18n.locale + '/login')
					}
					if (error?.response?.status == 422) {
						this.errorMessage.status = 422
						this.errorMessage.text = error.response.data.error_message
					}
					if (error?.response?.status == 403) {
						this.errorMessage.status = 403
						this.errorMessage.text = error?.response?.data?.message
					}
				})
		},

		// Тело POST /export повторяет фильтры списка, но с именами, которые ждёт бэк.
		buildExportPayload() {
			const query = this.$route.query
			const payload = {}

			const toIdArray = (raw) => {
				if (raw === undefined || raw === null || raw === '') return null
				const cleaned = (Array.isArray(raw) ? raw : [raw])
					.map((v) => (v != null ? String(v).trim() : ''))
					.filter((v) => v !== '' && v !== 'undefined')
					.map((v) => (isNaN(Number(v)) ? v : Number(v)))
				return cleaned.length ? cleaned : null
			}

			const pools = toIdArray(query['pools'] ?? query['pools[]'])
			if (pools) payload.pools = pools

			const regions = toIdArray(query['regions[]'] ?? query['regions'])
			if (regions) payload.regions = regions

			const reservoirs = toIdArray(query['reservoirs'] ?? query['reservoirs[]'])
			if (reservoirs) payload.reservoirs = reservoirs

			const catchTypes = toIdArray(
				query['catch_type_id'] ?? query['catch_type'] ?? query['catch_type_id[]'],
			)
			if (catchTypes) payload.catch_type_id = catchTypes

			if (query['search']) payload.search = query['search']
			// В списке start_at уходит на бэк как created_at — это фильтр «дата регистрации с»
			if (query['start_at']) payload.created_at = query['start_at']
			if (query['subject_kind']) payload.subject_kind = query['subject_kind']

			if (this.options?.sortBy?.length) {
				payload.sort = {
					[this.options.sortBy[0]]:
						!this.options.sortDesc?.length || !this.options.sortDesc[0] ? 'asc' : 'desc',
				}
			}

			return payload
		},
		async downloadExcel() {
			if (this.exporting) return

			this.exporting = true
			this.exportCancelled = false
			try {
				const { data } = await apiSecond.post(
					'v1/user/region/list/export',
					this.buildExportPayload(),
				)
				if (!data?.id) throw new Error('export id is missing')

				const status = await this.waitForExport(data.id)
				if (!status) return // ушли со страницы, пока формировался файл

				await this.downloadExportFile(data.id, status.file_name)
			} catch (error) {
				this.$toast.error(this.getExportErrorText(error), { timeout: 5000 })
			} finally {
				this.clearExportTimer()
				this.exporting = false
			}
		},
		waitForExport(id) {
			const poll = async (attempt) => {
				await new Promise((resolve) => {
					this.exportTimer = setTimeout(resolve, EXPORT_POLL_INTERVAL)
				})
				if (this.exportCancelled) return null

				const { data } = await apiSecond.get(`v1/export/${id}/status`)
				if (data?.status === 'done') return data
				if (data?.status === 'failed') throw new Error('export failed')
				if (attempt + 1 >= EXPORT_MAX_ATTEMPTS) throw new Error('export timeout')
				return poll(attempt + 1)
			}
			return poll(0)
		},
		async downloadExportFile(id, fileName) {
			const response = await apiSecond.get(`v1/export/${id}/download`, {
				responseType: 'arraybuffer',
			})

			const contentType =
				response.headers['content-type'] ||
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			// Бэк может ответить 200 с JSON-ошибкой вместо файла
			if (contentType.includes('application/json')) {
				const payload = this.parseArrayBufferMessage(response.data)
				const error = new Error('export download failed')
				error.exportMessage = payload?.error_message || payload?.message
				throw error
			}

			const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: contentType }))
			const fileLink = document.createElement('a')
			fileLink.href = fileURL
			fileLink.setAttribute('download', fileName || `trade-list-${id}.xlsx`)
			document.body.appendChild(fileLink)
			fileLink.click()
			document.body.removeChild(fileLink)
			window.URL.revokeObjectURL(fileURL)
		},
		parseArrayBufferMessage(data) {
			try {
				const text = data instanceof ArrayBuffer ? new TextDecoder('utf-8').decode(data) : data
				if (typeof text === 'string') return JSON.parse(text)
				return text
			} catch (e) {
				return null
			}
		},
		getExportErrorText(error) {
			const data = error?.response?.data
			const payload = data instanceof ArrayBuffer ? this.parseArrayBufferMessage(data) : data
			return (
				error?.exportMessage ||
				payload?.error_message ||
				payload?.message ||
				this.$t('system_message.excel_export_failed')
			)
		},
		clearExportTimer() {
			if (this.exportTimer) {
				clearTimeout(this.exportTimer)
				this.exportTimer = null
			}
		},
	},

	beforeCreate() {
		if (!localStorage.token) {
			this.$router.push('/ru/login')
		}
	},
	mounted() {
		// Set default regions filter for ТИР user by updating the route query
		if (this.isTir && this._getUserObject?.regions?.length) {
			const regionIds = this._getUserObject.regions.map((r) => r.region_id)
			// Регионы пишутся в query как regions[] — без этой проверки ТИР при каждом
			// обновлении попадал сюда и сбрасывался на первую страницу
			if (!this.$route.query.regions && !this.$route.query['regions[]']) {
				// Use array format for regions[]
				const query = {
					...this.$route.query,
					page: 1,
					filterTime: new Date().getTime(),
					per_page: this.options.itemsPerPage,
				}
				// Add regions[] as array
				query['regions[]'] = regionIds
				this.$router.replace({ query }).then(() => {
					this.search()
				})
			} else {
				// Не search(): он сбрасывает на первую страницу, а нужна страница из query
				this.pagination(this.options)
			}
		} else {
			this.pagination(this.options)
		}
	},
	beforeDestroy() {
		this.exportCancelled = true
		this.clearExportTimer()
	},
	head: {
		title() {
			return {
				inner: this.$t('sidebar.users_parent'),
			}
		},
		meta: [],
	},
}
</script>

<template>
	<div
		class="wrap__content"
		v-bind:class="{ 'wrap__content--preloader': !applications || !$store.state.userObject }"
	>
		<v-preloader v-if="!$store.state.userObject" :message="errorMessage"></v-preloader>

		<div class="container" v-if="$store.state.userObject">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['TradeManagementSupervisor']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content">
							<div class="card__content-header">
								<div class="content__title">
									<div class="content__title--element">
										<div class="content__title--text">
											{{ $t('sidebar.trade_list') }}
										</div>
									</div>
								</div>
							</div>
							<div class="card__content--body">
								<div class="table__block--content">
									<div class="mb-3 subject-kind-filter">
										<select :value="$route.query.subject_kind || ''" class="input-linck" @change="setSubjectKind($event.target.value)">
											<option value="">{{ $t('subject_kind.title') }}: {{ $t('filters.status_all') }}</option>
											<option v-for="kind in subjectKinds" :key="kind" :value="kind">{{ $t(`subject_kind.${kind}`) }}</option>
										</select>
									</div>
									<MainFilters
										:filter-keys="getFilters"
										:filter-options="{
											pools: { multiple: true },
											regions: { multiple: true },
											reservoirs: { multiple: true },
											catch_type: { multiple: true },
										}"
										:restricted-region-ids="restrictedRegionIds"
										class="mb-4"
										@search="search"
									>
										<template #actions>
											<button
												v-if="$store.getters.userPermission(['read_document_all'])"
												class="btn--link btn--link--secondary"
												:disabled="exporting"
												@click.prevent.stop="downloadExcel"
											>
												{{
													exporting ? $t('button.excel_generating') : $t('button.download_excel')
												}}
											</button>
										</template>
									</MainFilters>

									<v-data-table
										:headers="headers"
										:items="applications"
										:loading="false"
										:options.sync="options"
										:server-items-length="totalItems"
										:footer-props="{
											'items-per-page-options': [5, 10, 20, 30, 40, 50],
										}"
										@update:options="pagination"
									>
										<template v-slot:[`item.first_name`]="{ item }">
											<router-link
												v-if="$store.getters.userPermission(['read_document_all'])"
												:to="
													'/' + $i18n.locale + '/account/trade-list/' + item.id + '/user-profile'
												"
												class="tb__table--btn tb__table--view"
												v-tooltip.top-center="{
													content: 'Профиль субъекта',
													class: ['tooltip__btn'],
												}"
											>
												<template v-if="item.name_company">{{ item.name_company }}<br /></template>
												<template v-if="item.first_name"
													>{{ item.first_name }} {{ item.last_name }}
													{{ item.middle_name }}</template
												>
											</router-link>
										</template>
										<template v-slot:[`item.regions`]="{ item }">
											<div>
												{{
													item.regions
														.map(
															(region) =>
																region.region[`title${$i18n.locale == 'ru' ? '' : '_kz'}`],
														)
														.join(', ')
												}}
											</div>
										</template>
										<template v-slot:[`item.catch_types`]="{ item }">
											<div>
												{{
													item.catch_types && item.catch_types.length > 0
														? item.catch_types
																.map(
																	(catch_type) =>
																		catch_type.title ||
																		catch_type.name ||
																		catch_type.title_ru ||
																		catch_type.title_kz,
																)
																.join(', ')
														: '-'
												}}
											</div>
										</template>
										<template v-slot:[`item.created_at`]="{ item }">
											<div>
												{{ new Date(item.created_at).toLocaleDateString() }}
											</div>
										</template>

										<template v-slot:[`item.action`]="{ item }">
											<div class="flex">
												<router-link
													v-if="$store.getters.userPermission(['read_document_all'])"
													:to="
														'/' + $i18n.locale + '/account/trade-list/' + item.id + '/user-profile'
													"
													class="tb__table--btn tb__table--view"
													v-tooltip.top-center="{
														content: $t('labels.subject_profile'),
														class: ['tooltip__btn'],
													}"
												>
													<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.471 16.647v-1.5a3 3 0 00-3-3h-6a3 3 0 00-3 3v1.5M9.471 9.147a3 3 0 100-6 3 3 0 000 6z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
												</router-link>
												<router-link
													v-if="$store.getters.userPermission(['read_document_all'])"
													:to="'/' + $i18n.locale + '/account/trade-list/' + item.id + '/list'"
													class="tb__table--btn tb__table--view"
													v-tooltip.top-center="{
														content: $t('labels.view_journal'),
														class: ['tooltip__btn'],
													}"
												>
													<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9 16.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 12l3-3-3-3M6 9h6" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
												</router-link>
											</div>
										</template>
										<v-alert slot="no-results" :value="true" color="error">
											{{ $t('system_message.search') }}
										</v-alert>
									</v-data-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style>
header .header__row {
	display: flex;
}
</style>
